module.exports = __webpack_public_path__ + "120021edb32011d9207a2cfc093c0266.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/sm-320.jpg
// module id = 533
// module chunks = 0